
import {
  DocumentIcon,
  BoxIcon, UsersIcon, TruckIcon
} from "components/Icons/Icons";
import Client from "views/Pages/Client";
import Products from "views/Pages/Products";
import Orders from "views/Pages/Orders";
import Drivers from "views/Pages/Drivers";
import ResetPasswordInput from "views/Authentication/Login/ResetPasswordInput";
import { SettingsIcon } from '@chakra-ui/icons';
import LoginContainer from "views/Authentication/Login/LoginContainer";
import ProductContainer from "views/Products/ProductContainer";

const dashRoutes = [
  {
    name: "",
    category: "lista_paraggelion",
    items: [
      {
        name: "Λίστα Παραγγελιών",
        path: "/lista_paraggelion",
        component: Orders,
        layout: "/admin",
        icon: <DocumentIcon color="inherit" />,
        collapse: false,
      },
      {
        name: "Προϊόντα",
        path: "/products", // Change path to /products instead of /producta/*
        component: Products, // i.e., a wrapper with nested routes
        layout: "/admin",
        icon: <BoxIcon color="inherit" />,
        collapse: false,
      },
      {
        name: "Πελάτες",
        path: "/clients",
        component: Client,
        layout: "/admin",
        icon: <UsersIcon color="inherit" />,
        collapse: false,
      },
      {
        name: "Οδηγοί",
        path: "/drivers",
        component: Drivers,
        layout: "/admin",
        icon: <TruckIcon color="inherit" />,
        collapse: false,
      },
      {
        name: "Ρυθμίσεις",
        path: "/Ρυθμίσεις",
        layout: "/admin",
        component: LoginContainer,
        icon: <SettingsIcon color="inherit" />, // Chakra icon
        collapse: false,
      }
    ],
  },
];


export default dashRoutes;
